module.exports = __webpack_public_path__ + "img/login-bg.9446d1f9.png";